/* eslint-disable sort/object-properties */
/* eslint-disable sort/destructuring-properties */
import { be4feApi } from './be4feApi';

export type Be4feTagTypes =
  | 'apartment-admin'
  | 'elevator-integration'
  | 'access-control'
  | 'site-settings'
  | 'call-settings'
  | 'device-detail'
  | 'device-access'
  | 'integrations-installers';

export const enhancedBe4FEApi = be4feApi.enhanceEndpoints<Be4feTagTypes>({
  addTagTypes: [
    'apartment-admin',
    'elevator-integration',
    'access-control',
    'site-settings',
    'device-detail',
    'device-access',
    'integrations-installers',
  ],
  endpoints: {
    disableAppAccessAsAa: {
      invalidatesTags: [{ id: 'user-detail', type: 'apartment-admin' }],
    },
    editGuestInApartment: {
      invalidatesTags: [{ id: 'user-detail', type: 'apartment-admin' }],
    },
    editGuestInSite: {
      invalidatesTags: [{ id: 'user-credentials-validity', type: 'access-control' }],
    },
    elevatorIntegrationFloorMapping: {
      providesTags: [{ id: 'floor-mapping', type: 'elevator-integration' }],
    },
    enableAppAccessAsAa: {
      invalidatesTags: [{ id: 'user-detail', type: 'apartment-admin' }],
    },
    getApartmentUserForAaById: {
      providesTags: [{ id: 'user-detail', type: 'apartment-admin' }],
    },
    getSite: {
      providesTags: [{ id: 'site', type: 'site-settings' }],
    },
    getUnlockOverApiForDevice: {
      providesTags: [{ id: 'unlock-over-api-for-device', type: 'device-detail' }],
    },
    getDeviceAcods: {
      providesTags: [{ id: 'get-device-acods', type: 'device-access' }],
    },
    getSiteTypeChangePrecheck: {
      keepUnusedDataFor: 0,
    },
    migrateUserAsApartmentAdmin: {
      invalidatesTags: [{ id: 'user-detail', type: 'apartment-admin' }],
    },
    migrateUserWithAppAccessActivation: {
      invalidatesTags: [{ id: 'user-detail', type: 'apartment-admin' }],
    },
    migrateUserWithDeviceActivation: {
      invalidatesTags: [{ id: 'user-detail', type: 'apartment-admin' }],
    },
    updateUserBasicInfoInApartment: {
      invalidatesTags: [{ id: 'user-detail', type: 'apartment-admin' }],
    },
    setDeviceUnlockOverApiService: {
      invalidatesTags: [{ id: 'unlock-over-api-for-device', type: 'device-detail' }],
    },
    getApartmentDetailForAa: {
      providesTags: [{ id: 'apartment-detail', type: 'apartment-admin' }],
    },
    createSiteContact: {
      invalidatesTags: [{ id: 'site', type: 'site-settings' }],
    },
    deleteSiteContactById: {
      invalidatesTags: [{ id: 'site', type: 'site-settings' }],
    },
    updateSiteContactById: {
      invalidatesTags: [{ id: 'site', type: 'site-settings' }],
    },
    updateSite: {
      invalidatesTags: [
        { id: 'site', type: 'site-settings' },
        { id: 'integrations', type: 'integrations-installers' },
      ],
    },
    addSiteInstaller: {
      invalidatesTags: [{ id: 'integrations', type: 'integrations-installers' }],
    },
    removeSiteInstaller: {
      invalidatesTags: [{ id: 'integrations', type: 'integrations-installers' }],
    },
    getSiteInstallers: {
      providesTags: [{ id: 'integrations', type: 'integrations-installers' }],
    },
    addAcodToDevice: {
      invalidatesTags: [{ id: 'get-device-acods', type: 'device-access' }],
    },
    removeAcodFromDevice: {
      invalidatesTags: [{ id: 'get-device-acods', type: 'device-access' }],
    },
  },
});
